import {
    getAuth,
    EmailAuthProvider,
    reauthenticateWithCredential,
    getMultiFactorResolver,
    TotpMultiFactorGenerator,
} from "firebase/auth";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

const reauthenticateUser = async (data) => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
        throw new Error("User not authenticated");
    }

    const credential = EmailAuthProvider.credential(user.email, data.password);

    try {
        await reauthenticateWithCredential(user, credential);
    } catch (err) {
        if (err.code === "auth/multi-factor-auth-required") {
            return {
                mfaRequired: true,
                resolver: getMultiFactorResolver(auth, err),
            };
        }

        if (err.code === "auth/invalid-credential") {
            toast.error("Your password is incorrect");
        } else {
            toast.error("Something went wrong");
        }

        throw err;
    }

    return { mfaRequired: false };
};

export const useReauthenticateUser = () => {
    return useMutation({
        mutationFn: reauthenticateUser,
        retry: false,
    });
};

const verifyReauthenticationMfa = async ({ resolver, code }) => {
    const assertion = TotpMultiFactorGenerator.assertionForSignIn(
        resolver.hints[0].uid,
        code,
    );

    await resolver.resolveSignIn(assertion);
};

export const useVerifyReauthenticationMfa = (onReauthenticated) => {
    return useMutation({
        mutationFn: verifyReauthenticationMfa,
        retry: false,

        onSuccess: () => {
            onReauthenticated();
        },

        onError: (err) => {
            if (err.code === "auth/invalid-verification-code") {
                toast.error("That code is incorrect");
            } else {
                toast.error("Error verifying authentication code");
            }
        },
    });
};
